import { render, staticRenderFns } from "./Transponder.vue?vue&type=template&id=fb9d3a28&scoped=true&"
import script from "./Transponder.vue?vue&type=script&lang=js&"
export * from "./Transponder.vue?vue&type=script&lang=js&"
import style0 from "./Transponder.vue?vue&type=style&index=0&id=fb9d3a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9d3a28",
  null
  
)

export default component.exports